import React from "react";

export default function ColorFrame36({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <rect
          width="184"
          height="160"
          x="4"
          y="40"
          fill="#7A6FF7"
          rx="6.282"
        ></rect>
        <path
          fill="#6B7E97"
          d="M202.824 213c.649 0 1.176-.4 1.176-.894V86.443c0-.494-.527-.894-1.176-.894h-7.648c-.649 0-1.176.4-1.176.894v125.663c0 .494.527.894 1.176.894h7.648z"
        ></path>
        <path
          fill="#6B7E97"
          d="M199.882 193.771c.65 0 1.177-.401 1.177-.895V67.214c0-.494-.527-.895-1.177-.895h-1.764c-.65 0-1.177.4-1.177.895v125.662c0 .494.527.895 1.177.895h1.764z"
        ></path>
        <path
          fill="#6B7E97"
          d="M200.634 67.892c.47-.341.488-.907.04-1.265l-2.945-2.35c-.448-.357-1.193-.37-1.663-.03l-1.278.925c-.47.341-.488.907-.04 1.265l2.945 2.35c.448.357 1.193.37 1.663.03l1.278-.925z"
        ></path>
        <rect width="192" height="16" y="194" fill="#313B48" rx="3.351"></rect>
        <path
          fill="#ED583C"
          d="M188 108h41.956C252.624 108 271 126.376 271 149.044V196h-83v-88z"
        ></path>
        <path
          fill="#D8E6FD"
          d="M208.989 117.481a2.513 2.513 0 012.513-2.513h20.683c16.565 0 29.994 13.429 29.994 29.994a1.836 1.836 0 01-1.836 1.836h-48.841a2.513 2.513 0 01-2.513-2.513v-26.804z"
        ></path>
        <mask
          id="mask0_2257_162514"
          style={{ maskType: "alpha" }}
          width="55"
          height="33"
          x="208"
          y="114"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#fff"
            d="M208.989 117.481a2.513 2.513 0 012.513-2.513h20.683c16.565 0 29.994 13.429 29.994 29.994a1.836 1.836 0 01-1.836 1.836h-48.841a2.513 2.513 0 01-2.513-2.513v-26.804z"
          ></path>
        </mask>
        <g mask="url(#mask0_2257_162514)">
          <path
            fill="#fff"
            fillOpacity="0.7"
            d="M217.452 106.18l-15.254 10.03 26.627 47.724 34.101-9.612-45.474-48.142z"
          ></path>
        </g>
        <rect
          width="90"
          height="16"
          x="186"
          y="194"
          fill="#313B48"
          rx="3.351"
        ></rect>
        <rect
          width="104.344"
          height="104.344"
          x="44.156"
          y="61.54"
          fill="#fff"
          stroke="#ED583C"
          strokeWidth="7"
          rx="9.5"
        ></rect>
        <path
          fill="#313B48"
          d="M79.156 204.604c0 15.271-14.516-12.388-31.054-12.388-16.538 0-28.836 27.659-28.836 12.388 0-15.272 13.407-27.651 29.945-27.651s29.945 12.379 29.945 27.651zM245.845 204.604c0 15.271-14.516-12.388-31.054-12.388-16.538 0-28.836 27.659-28.836 12.388 0-15.272 13.407-27.651 29.945-27.651s29.945 12.379 29.945 27.651z"
        ></path>
        <circle cx="217.156" cy="211.505" r="24.501" fill="#3E4957"></circle>
        <circle cx="49.63" cy="211.505" r="24.501" fill="#3E4957"></circle>
        <circle cx="217.156" cy="211.505" r="11.518" fill="#6B7E97"></circle>
        <circle cx="49.63" cy="211.505" r="11.518" fill="#6B7E97"></circle>
        <ellipse
          cx="270.137"
          cy="174.859"
          fill="#FFD336"
          rx="3.351"
          ry="6.701"
        ></ellipse>
        {children}
      </g>
    </svg>
  );
}
